/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../common";
import type {
  NameServiceLogic,
  NameServiceLogicInterface,
} from "../../../contracts/nameService/NameServiceLogic";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    stateMutability: "payable",
    type: "fallback",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "keyName",
        type: "bytes32",
      },
    ],
    name: "getSingle",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "keyName",
        type: "bytes32",
      },
    ],
    name: "getSingleSafe",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "which",
        type: "address",
      },
    ],
    name: "isBlocked",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "keyName",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "which",
        type: "address",
      },
    ],
    name: "isMultiple",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "keyName",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "which",
        type: "address",
      },
    ],
    name: "isMultipleSafe",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "which",
        type: "address",
      },
    ],
    name: "isPrivileged",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "isTrusted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "listMultipleEntries",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "name",
            type: "bytes32",
          },
          {
            components: [
              {
                internalType: "address",
                name: "addr",
                type: "address",
              },
              {
                internalType: "bool",
                name: "trusted",
                type: "bool",
              },
            ],
            internalType: "struct GenericNameServiceType.AddressRecord[]",
            name: "records",
            type: "tuple[]",
          },
        ],
        internalType: "struct GenericNameServiceType.MultipleEntryRet[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "listSeparatedTrustEntries",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "addr",
            type: "address",
          },
          {
            internalType: "bool",
            name: "trusted",
            type: "bool",
          },
        ],
        internalType: "struct GenericNameServiceType.AddressRecord[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "listSingleEntries",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "name",
            type: "bytes32",
          },
          {
            components: [
              {
                internalType: "address",
                name: "addr",
                type: "address",
              },
              {
                internalType: "bool",
                name: "trusted",
                type: "bool",
              },
            ],
            internalType: "struct GenericNameServiceType.AddressRecord",
            name: "record",
            type: "tuple",
          },
        ],
        internalType: "struct GenericNameServiceType.SingleEntryRet[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAssociatedOperator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setAssociatedOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "list",
        type: "address[]",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setBlockList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "keyName",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "which",
        type: "address",
      },
      {
        internalType: "bool",
        name: "enable",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "trusted",
        type: "bool",
      },
    ],
    name: "setMultiple",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "keyName",
        type: "bytes32[]",
      },
      {
        internalType: "address[]",
        name: "which",
        type: "address[]",
      },
      {
        internalType: "bool[]",
        name: "enable",
        type: "bool[]",
      },
      {
        internalType: "bool[]",
        name: "trusted",
        type: "bool[]",
      },
    ],
    name: "setMultipleEntries",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "list",
        type: "address[]",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setPrivilegedList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "which",
        type: "address",
      },
      {
        internalType: "bool",
        name: "enable",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "trusted",
        type: "bool",
      },
    ],
    name: "setSeparatedTrustAddress",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "which",
        type: "address[]",
      },
      {
        internalType: "bool[]",
        name: "enable",
        type: "bool[]",
      },
      {
        internalType: "bool[]",
        name: "trusted",
        type: "bool[]",
      },
    ],
    name: "setSeparatedTrustEntries",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "keyName",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "which",
        type: "address",
      },
      {
        internalType: "bool",
        name: "enable",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "trusted",
        type: "bool",
      },
    ],
    name: "setSingle",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "keyName",
        type: "bytes32[]",
      },
      {
        internalType: "address[]",
        name: "which",
        type: "address[]",
      },
      {
        internalType: "bool[]",
        name: "enable",
        type: "bool[]",
      },
      {
        internalType: "bool[]",
        name: "trusted",
        type: "bool[]",
      },
    ],
    name: "setSingleEntries",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
] as const;

const _bytecode =
  "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";

type NameServiceLogicConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: NameServiceLogicConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class NameServiceLogic__factory extends ContractFactory {
  constructor(...args: NameServiceLogicConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<NameServiceLogic> {
    return super.deploy(overrides || {}) as Promise<NameServiceLogic>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): NameServiceLogic {
    return super.attach(address) as NameServiceLogic;
  }
  override connect(signer: Signer): NameServiceLogic__factory {
    return super.connect(signer) as NameServiceLogic__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): NameServiceLogicInterface {
    return new utils.Interface(_abi) as NameServiceLogicInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): NameServiceLogic {
    return new Contract(address, _abi, signerOrProvider) as NameServiceLogic;
  }
}
